const en = {
  common: {
    save: 'Save', saveChanges: 'Save changes', cancel: 'Cancel', delete: 'Delete',
    edit: 'Edit', add: 'Add', remove: 'Remove', close: 'Close', back: 'Back',
    retry: 'Retry', loading: 'Loading…', search: 'Search', all: 'All',
    status: 'Status', actions: 'Actions', name: 'Name', email: 'Email', phone: 'Phone',
    role: 'Role', date: 'Date', joined: 'Joined', active: 'Active', inactive: 'Inactive',
    banned: 'Banned', yes: 'Yes', no: 'No', showing: 'Showing', of: 'of',
    somethingWrong: 'Something went wrong', noResults: 'No results', clear: 'Clear',
    unknown: 'Unknown',
  },
  nav: {
    main: 'Main', admin: 'Admin',
    home: 'Home', courses: 'Courses', students: 'Students', clients: 'Clients', sales: 'Sales',
    leads: 'Leads', reminders: 'Reminders', promocodes: 'Promocodes', inbox: 'Inbox', analytics: 'Analytics',
    calendar: 'Calendar', team: 'Team', teams: 'Teams', settings: 'Settings', logout: 'Logout',
    account: 'Account', workspace: 'Workspace', operations: 'Operations', insights: 'Insights', collapse: 'Collapse sidebar', expand: 'Expand sidebar', openMenu: 'Open navigation', aiProposals: '{count} courses with AI proposals pending review',
  },
  topbar: {
    language: 'Language', notifications: 'Notifications', profile: 'Profile',
    signOut: 'Sign out', theme: 'Theme', newCourse: 'New course', noNotifications: 'No notifications',
    eyebrow: {
      workspace: 'Workspace', courses: 'Courses', catalog: 'Catalog', people: 'People',
      commerce: 'Commerce', communication: 'Communication', insights: 'Insights',
      planning: 'Planning', account: 'Account',
    },
    title: {
      home: 'Home', createCourse: 'Create course', courseWorkspace: 'Course workspace',
      courses: 'Courses', students: 'Students', clients: 'Clients', sales: 'Sales', inbox: 'Inbox',
      analytics: 'Analytics', calendar: 'Calendar', team: 'Team', settings: 'Settings',
      studentDetail: 'Student detail', profile: 'Profile', quizFeedback: 'Quiz feedback', clientDetail: 'Client', mentors: 'Mentors',
    },
  },
  students: {
    title: 'Students', subtitle: 'Enrollment roster & progress by course',
    selectCourse: 'Select a course…', searchPlaceholder: 'Search name, email or phone',
    pickTitle: 'Pick a course to get started',
    pickDesc: 'Choose one of your courses above to see enrolled students, their progress and status.',
    emptyTitle: 'No students enrolled yet',
    emptyDesc: 'Once students enroll in this course, they will appear here.',
    totalEnrolled: 'Total enrolled', avgProgress: 'Avg. progress', completed: 'Completed', inProgress: 'In progress',
    filterAll: 'All', filterInProgress: 'In progress', filterCompleted: 'Completed', filterNotStarted: 'Not started', filterInactive: 'No access',
    statusCompleted: 'Completed', statusInProgress: 'In progress', statusNotStarted: 'Not started', statusInactive: 'No access',
    colStudent: 'Student', colProgress: 'Progress', colStatus: 'Status', colEnrolled: 'Enrolled', colCompleted: 'Completed',
    noMatch: 'No students match this filter.', showingStudents: 'students',
    rosterCapped: 'Only the first {loaded} of {total} students are loaded; the counts and search cover those.',
    colGroups: 'Groups', addToGroup: 'Add', assignHead: 'Add to a group', inAllGroups: 'Already in all groups', allGroups: 'All groups',
    rosterEyebrow: 'Enrollment roster', rosterCount: '{count} students enrolled',
    addedToGroup: 'Added to {group}', addGroupFailed: 'Could not add to group',
    noGroupsYet: 'No groups yet — create one on the Teams page.',
    view: 'View', viewDetail: 'View student details', detailClose: 'Close', detailLoadFail: 'Could not load student details',
    backToRoster: 'Back to students', detailStudent: 'Student', detailCompletedOn: 'Completed {date}',
    detailOverall: 'Overall progress', detailLessons: 'Lessons done', detailAvgQuiz: 'Avg. quiz score', detailEnrolled: 'Enrolled',
    detailLessonsSection: 'Lesson progress', detailQuizzes: 'Quiz attempts', detailActivity: 'Recent activity',
    detailNoLessons: 'No lesson activity yet.', detailCorrect: '{correct}/{total} correct',
    lessonN: 'Lesson {n}', quizN: 'Quiz {n}',
    loading: 'Loading students…', tabAllStudents: 'All students', tabAtRisk: 'At risk',
  },
  orders: {
    title: 'Orders', subtitle: 'Payments & order history for your courses',
    searchPlaceholder: 'Search customer or course',
    emptyTitle: 'No orders yet', emptyDesc: 'When students purchase your courses, their orders will appear here.',
    totalRevenue: 'Total revenue', ordersCount: 'Orders', completed: 'Completed', avgOrder: 'Avg. order value',
    colCustomer: 'Customer', colCourse: 'Course', colAmount: 'Amount', colStatus: 'Status', colDate: 'Date',
    noMatch: 'No orders match this filter.', showingOrders: 'orders', loading: 'Loading orders…',
  },
  discounts: {
    title: 'Discounts',
  },
  feedback: {
    title: 'Feedback', subtitle: 'Course reviews & ratings from your students',
    emptyTitle: 'No feedback yet', emptyDesc: 'When students leave feedback on your courses, it will appear here.',
    all: 'All', outOf5: '{value} out of 5',
  },
  team: {
    eyebrow: 'Organisation', hubSubtitle: 'Manage staff accounts and organise them into call-center, sales and control teams.', tabPeople: 'People', tabTeams: 'Teams',
    title: 'Team', memberCount: '{count} members in your account', memberCountOne: '1 member in your account',
    addMember: 'Add member', addTeamMember: 'Add team member', editMember: 'Edit member',
    total: 'Total', admins: 'Admins', teachers: 'Teachers', students: 'Students',
    searchPlaceholder: 'Search by name or email…',
    roleAll: 'All', roleAdmin: 'Admin', roleTeacher: 'Teacher', roleStudent: 'Student',
    sortNewest: 'Newest first', sortOldest: 'Oldest first', sortNameAsc: 'Name A–Z', sortNameDesc: 'Name Z–A',
    colMember: 'Member', colContact: 'Contact', colRole: 'Role', colStatus: 'Status', colJoined: 'Joined', colActions: 'Actions',
    fullName: 'Full name', password: 'Password', newPassword: 'New password',
    passwordHint: 'Leave blank to keep current password', statusActive: 'Active', statusInactive: 'Inactive',
    ban: 'Ban', unban: 'Unban', emptyTitle: 'No members found', emptyDesc: 'Try adjusting filters or add a new team member',
    removeTitle: 'Remove member?', removeMsg: '"{name}" will be permanently removed from your account.',
    banTitle: 'Ban member?', banMsg: '"{name}" will be banned and lose access to your account.',
    unbanTitle: 'Unban member?', unbanMsg: '"{name}" will regain access to your account.',
    sort: 'Sort', changeRole: 'Change role', viewGrid: 'Grid', viewTable: 'Table',
    namePlaceholder: 'John Doe', emailPlaceholder: 'user@example.com', phonePlaceholder: '+998901234567',
    passwordPlaceholder: 'Min 6 characters', saving: 'Saving…',
    nameRequired: 'Name is required', passwordRequired: 'Password is required for new members',
    failedToSave: 'Failed to save', failedToLoad: 'Failed to load team',
    failedToUpdateRole: 'Failed to update role', failedToDelete: 'Failed to delete member',
    failedToUpdateBan: 'Failed to update ban status',
    roleChanged: "{name}'s role changed to {role}", removedToast: '{name} removed',
    bannedToast: '{name} banned', unbannedToast: '{name} unbanned',
    memberUpdated: 'Member updated', memberAdded: 'Member added',
    showingRange: 'Showing {from}–{to} of {total}',
  },
  settings: {
    title: 'Settings', subtitle: 'Manage your profile, account, and preferences',
    navProfile: 'Profile', navAccount: 'Account', navPassword: 'Password', navSession: 'Session',
    profileTitle: 'Profile', profileDesc: 'This information is visible to students and other team members.',
    yourName: 'Your name', fullName: 'Full name', fullNamePlaceholder: 'Your full name',
    subjectArea: 'Subject area', selectSubject: 'Select a subject',
    bio: 'Bio', bioPlaceholder: 'Tell students about yourself, your experience, and teaching style',
    uploadPhoto: 'Upload photo', avatarAlt: 'Avatar',
    accountTitle: 'Account', accountDesc: 'Your login credentials and account details.',
    accountId: 'Account ID',
    passwordTitle: 'Change password', passwordDesc: "Use a strong password you don't use elsewhere.",
    currentPassword: 'Current password', newPassword: 'New password', confirmPassword: 'Confirm new password',
    currentPasswordPlaceholder: 'Enter current password', newPasswordPlaceholder: 'Min 6 characters',
    confirmPasswordPlaceholder: 'Re-enter new password',
    updatePassword: 'Update password',
    pwMinLength: 'Password must be at least 6 characters', pwMismatch: 'Passwords do not match',
    pwNotAvailable: 'Password change is not available yet',
    sessionTitle: 'Session', signOut: 'Sign out', signOutDesc: 'End your current session on this device.',
    signOutQ: 'Sign out?', signOutConfirm: "You'll need to sign in again to access your account. Any unsaved changes will be lost.",
    saved: 'Profile saved', saving: 'Saving…',
    nameRequired: 'Name is required', loadFailed: 'Failed to load profile', saveFailed: 'Failed to save',
    loadingSettings: 'Loading settings…',
    subjects: {
      mathematics: 'Mathematics', english: 'English', science: 'Science', history: 'History',
      languages: 'Languages', technology: 'Technology', arts: 'Arts', other: 'Other',
    },
  },
  calendar: {
    today: 'Today', month: 'Month', week: 'Week', newEvent: 'New event',
    categories: 'Categories', allEvents: 'All events', addCategory: 'Add category',
    pinned: 'Pinned', loading: 'Loading calendar…',
    newEventTitle: 'New event', editEventTitle: 'Edit event', newCategory: 'New category', editCategory: 'Edit category',
    fName: 'Name', fTitle: 'Title', fDate: 'Date', fTime: 'Time', fDescription: 'Description', fCategory: 'Category',
    fColor: 'Color', fIcon: 'Icon', noCategory: '— No category —', pinEvent: 'Pin this event to the top',
    create: 'Create', update: 'Update',
    placeholderCategoryName: 'e.g. Mathematics', placeholderEventTitle: 'Event title',
    placeholderEventTime: '10:00 - 12:00', placeholderDescription: 'Optional notes…',
    saving: 'Saving…', moreEvents: '+{count} more', previous: 'Previous', next: 'Next',
    failedToLoad: 'Failed to load calendar data', failedToSaveEvent: 'Failed to save event',
    failedToDeleteEvent: 'Failed to delete event', failedToSaveCategory: 'Failed to save category',
    failedToDeleteCategory: 'Failed to delete category',
    confirmDeleteEvent: 'Delete this event?',
    confirmDeleteCategory: 'Delete this category? Events will become uncategorised.',
  },
};

export default en;
